import { render, staticRenderFns } from "./ScheduleSetup.vue?vue&type=template&id=22dc9a78&"
import script from "./ScheduleSetup.vue?vue&type=script&lang=js&"
export * from "./ScheduleSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports